import { BaseStatusDto } from '../baseStatusDto';

export class AuditFormScheduleStatusDto extends BaseStatusDto {}
